<template>
  <el-card class="box-card" shadow="hover">
    <div slot="header" class="clearfix">
      <span>修改手机号码</span>
    </div>
    <div class="item">
      <el-form
        ref="ruleForm"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
        class="formWrap"
      >
        <el-form-item label="账户手机号: ">
          <el-input v-model="ruleForm.name" disabled></el-input>
        </el-form-item>

        <div class="codeWrap">
          <el-form-item label="验证码: " prop="code" class="codeInput">
            <el-input
              v-model="ruleForm.code"
              placeholder="验证码"
              prefix-icon="el-icon-document-checked"
            ></el-input>
          </el-form-item>
          <div
            style="
              width: 120px;
              height: 40px;
              cursor: pointer;
              margin-left: 20px;
            "
          >
            <img
              :src="computedBaseURl + '/api/v1/util/imgCaptcha?timestamp=' + time"
              alt=""
              width="auto"
              height="100%"
              @click="refreshImg"
              ref="verifyImg"
            />
          </div>
        </div>

        <!-- phonecode -->
        <div class="codeWrap">
          <el-form-item
            label="动态码: "
            prop="phoneCode"
            class="phoneCodeInput"
          >
            <el-input
              v-model="ruleForm.phoneCode"
              placeholder="动态码"
              prefix-icon="el-icon-phone-outline"
              autoComplete="off"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            plain
            style="
              width: 100px;
              height: 42px;
              padding-right: 0;
              padding-left: 0;
              margin-left: 20px;
            "
            @click="getPhoneCode"
            :disabled="disabledBtn"
            v-loading="loading"
            element-loading-text="请查看手机"
            element-loading-spinner="el-icon-loading"
            >获取动态码</el-button
          >
        </div>
        <el-form-item label="新手机号: " prop="newName">
          <el-input v-model="ruleForm.newName"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit('ruleForm')"
            >下一步</el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      disabledBtn: false,
      activeStep: 0,
      time: "",
      ruleForm: {
        name: "12",
        newName: "",
        code: "",
        phoneCode: "",
      },
      rules: {
        code: [
          { required: true, message: "请输入验证码", trigger: "blur" },
          { min: 4, max: 4, message: "长度在 4 个字符", trigger: "blur" },
        ],
        phoneCode: [
          { required: true, message: "请输入动态码", trigger: "blur" },
          { min: 6, max: 6, message: "输入6位动态码", trigger: "blur" },
        ],
        newName: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            min: 11,
            max: 11,
            message: "长度为11个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  mounted() {
    this.refreshImg();
  },
  methods: {
    onSubmit(ref) {
      if (this.ruleForm.code && this.ruleForm.phoneCode) {
        this.axios({
          url: "/api/v1/user/verifyIdentidy",
          method: "post",
          data: {
            name: this.ruleForm.name,
            code: this.ruleForm.code,
            phoneCode: this.ruleForm.phoneCode,
            sms_flag: "1",
          },
        }).then((res) => {
          if (res.data.code > 0) {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          } else {
            this.$refs["ruleForm"].validate((valid) => {
              if (valid) {
                this.axios({
                  url: "/api/v1/user/bindingPhone",
                  method: "post",
                  data: {
                    name: this.ruleForm.newName,
                    code: this.ruleForm.code,
                    phoneCode: this.ruleForm.phoneCode,
                  },
                }).then((res) => {
                  if (res.data.code > 0) {
                    this.$message({
                      message: res.data.msg,
                      type: "error",
                    });
                  } else {
                    this.$message({
                      message: res.data.msg,
                      type: "success",
                    });
                    setTimeout(() => {
                      this.$router.push("/userCenter");
                    }, 1000);
                  }
                });
              }
            });
          }
        });
      } else {
        this.$message({
          message: "请输入内容",
          type: "error",
        });
      }
    },

    refreshImg() {
      var time = new Date().getTime();
      this.time = time;
      this.$refs.verifyImg.src =
        this.computedBaseURl + "/api/v1/util/imgCaptcha?timestamp=" + this.time;
      this.ruleForm.code = "";
    },

    getPhoneCode() {
      if (this.ruleForm.code && this.ruleForm.code.length == 4) {
        this.loading = true;
        this.disabledBtn = true;
        this.axios
          .post("/api/v1/user/sendSms", {
            name: this.ruleForm.name,
            code: this.ruleForm.code,
            sms_flag: "1",
            img_timestamp: this.time,
          })
          .then((res) => {
            if (res.data.code > 0) {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "success",
              });
            }
            this.loading = false;
            this.disabledBtn = false;
          })
          .catch((res) => {
            this.$message({
              message: res,
              type: "error",
            });
            this.loading = false;
            this.disabledBtn = false;
          });
      } else {
        this.$message({
          message: "需要输入正确的验证码",
          type: "error",
        });
      }
    },
  },
  watch: {
    "$store.state.name": {
      handler(n, o) {
        this.ruleForm.name = this.$store.state.name;
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    computedBaseURl() {
      return this.$store.state.baseURL;
    },
  },
};
</script>

<style scoped>
.box-card {
  text-align: left;
  margin-left: 20px;
}
.item {
  text-align: center;
}
.codeWrap {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.successAlert {
  width: 500px;
  margin: 20px auto;
  height: 300px;
  color: #e6a23c;
  line-height: 300px;
  font-size: 20px;
}
.formWrap {
  width: 600px;
  margin: 20px auto;
}
</style>